import { render, staticRenderFns } from "./membercard.vue?vue&type=template&id=d2dbdae4&scoped=true&"
import script from "./membercard.vue?vue&type=script&lang=js&"
export * from "./membercard.vue?vue&type=script&lang=js&"
import style0 from "./membercard.vue?vue&type=style&index=0&id=d2dbdae4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2dbdae4",
  null
  
)

export default component.exports